import AudioPlayer from './src/AudioPlayer'
import _AudioPlayerMobile from './src/AudioPlayerMobile'

export const AudioPlayerMobile = _AudioPlayerMobile
export default AudioPlayer
